const listings = (state = {}, action) => {
  switch (action.type) {
  case 'GET_HOST_LISTING_DETAILS':
    if (action.error) return state;
    return { listingDetails: action.data.data };

  default:
    return state;
  }
};

export default listings;
